
import React, { Component, useState } from 'react'
import * as support from '../../api/support'
import { Alert, Row, Col, ListGroup, ListGroupItem, Button, Modal } from 'react-bootstrap'
import StatusMessage from "../../lib/statusmessage"
import MySupportEditor from './my-support-editor';
import moment from "moment"
import FileSaver from "file-saver"
import { withRouter, useRouteMatch, Link } from "react-router-dom";
import LoadingModal from './loading-modal'
import PulseLoader from "react-spinners/PulseLoader";

class MyCase extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Case: null,
            Alert: null,
            ClearChildAlerts: null,
            UserID: this.props.UserID,
            Uploading: false,
            confirmAction: null,
            reopenAttachments:null,
            reopenReply:null,
            CaseID: props.match.params.caseid,
            EnvSettings: this.props.EnvSettings
        }
        this.GetCase = this.GetCase.bind(this);
        this.addReply = this.addReply.bind(this);
        this.handleShowConfirmModal = this.handleShowConfirmModal.bind(this);
        this.handleModalConfirmAction = this.handleModalConfirmAction.bind(this);
        this.handleModalConfirmReopen = this.handleModalConfirmReopen.bind(this);
        this.changeCaseStatus = this.changeCaseStatus.bind(this);
        this.fetchFile = this.fetchFile.bind(this);
        this.clearAlerts = this.clearAlerts.bind(this);
        this.Editor = React.createRef();


    }

    componentDidUpdate(prevProps) {
        if (prevProps && prevProps.CaseID != this.props.CaseID) {
            this.setState({ "CaseID": this.props.CaseID, "Alert": null }, () => {
                this.GetCase();
            });
        }

        if (prevProps && prevProps.EnvSettings != this.props.EnvSettings) {
            this.setState({
                EnvSettings: this.props.EnvSettings
            })
        }
    }

    GetCase = async () => {
        try {
            this.setState({ Loading: true });
            let _case = await support.GetCaseDetail(this.state.CaseID);
            this.setState({ Case: _case });
        } catch (ex) {
            console.log(ex);
        } finally {
            this.setState({ Loading: false });
        }
    }

    addReply = async (reply, attachments) => {

        try {
            this.setState({ Loading: true });

            let data = {
                "CaseGuid": this.state.Case.Case.CaseGuid,
                "ContactGuid": this.state.Case.Case.ContactGuid,
                "Title": this.state.Case.Case.Title,
                "Description": reply,
                "Attachments": attachments.map(att => { return att.attachment }) || []
            }

            await support.AddReplyToCase(data);
            this.setState({
                Alert: new StatusMessage({
                    Status: "success",
                    Message: `Your reply has been added to the case.`,
                })

            })
            this.GetCase();
            this.Editor.current.reset();

        } catch (ex) {
            console.log(ex);
            this.setState({
                Alert: new StatusMessage({
                    Status: "danger",
                    Message: `${ex.message}`,
                })

            })
        } finally {
            this.setState({ Loading: false });
        }
    }

    handleShowConfirmModal = async (yesno) => {
        this.setState({
            showConfirmModal: yesno
        })
    }

    handleModalConfirmAction = async (actionString) => {
        this.setState({
            confirmAction: actionString,
            showConfirmModal: true
        })
    }

    handleModalConfirmReopen = async (actionString, reply, attachments)=>{
        this.setState({
            confirmAction: actionString,
            showConfirmModal: true,
            reopenReply: reply,
            reopenAttachments: attachments
        })
    }
    changeCaseStatus = async (action) => {
        try {
            this.setState({ Loading: true });

            let data = {
                "CaseGuid": this.state.Case.Case.CaseGuid,
                "ContactGuid": this.state.Case.Case.ContactGuid,
                "Action": action // 1 to re-open case, 2 to close case
            }

            await support.UpdateCaseAction(data);
            if(typeof(this.state.reopenReply) =="undefined" || this.state.reopenReply==null){
                await this.GetCase(this.state.Case.Case.CaseGuid);
            }

        } catch (ex) {
            console.log(ex);
            this.setState({
                Alert: new StatusMessage({
                    Status: "danger",
                    Message: `${ex.message}`,
                })

            })
        } finally {
            this.setState({ Loading: false });
        }
    }

    fetchFile = async (filepath, filename) => {
        let file = await fetch(filepath);
        // Extract filename from header
        /*
        const filename = file.headers.get('content-disposition')
            .split(';')
            .find(n => n.includes('filename='))
            .replace('filename=', '')
            .trim()
            ;
            */
        FileSaver.saveAs(await file.blob(), filename);

    }

    clearAlerts = () => {
        this.setState({
            Alert: null
        })

        this.Editor.current.clearAlerts();
    }

    componentWillMount() {
        this.GetCase();
    }

    render() {
        return (
            <div className={`my-support-section my-support-case-wrap`}>
                <div className={`case-comments-wrapper`}>
                    <LoadingModal display={this.state.Loading} />
                    {this.state.Case &&
                        <Row className={`my-support-case-meta`}>
                            <Col md="9" className={`my-support-case-meta-inner`}>
                                <h2>{this.state.Case.Case.Title}</h2>

                                {(
                                    () => {
                                        let _settings = {};
                                        if (this.state.Case.Case.ProductData?.Product && this.state.EnvSettings?.ProductSettings?.Products) {
                                            _settings.Product = this.state.EnvSettings.ProductSettings.Products.find(x => {
                                                return x.CRMProductGuid == this.state.Case.Case.ProductData.Product;
                                            });

                                            if (_settings.Product) {
                                                _settings.Platform = _settings.Product.Platforms.find(x => {
                                                    return x.CRMProductGuid == this.state.Case.Case.ProductData.Platform;
                                                });
                                                if (_settings.Platform) {
                                                    _settings.Control = _settings.Platform.Controls.find(x => {
                                                        return x.CRMProductGuid == this.state.Case.Case.ProductData.Control;
                                                    });
                                                }
                                            }


                                            return (
                                                <>
                                                    <p><b>Case ID:</b> {this.state.Case.Case.CaseNumber}</p>
                                                    {_settings.Product && <p><b>Product:</b> {_settings.Product.Name}</p>}
                                                    {_settings.Platform && <p><b>Platform:</b> {_settings.Platform.Name}</p>}
                                                    {_settings.Control && <p><b>Control:</b> {_settings.Control.Name}</p>}
                                                </>
                                            );
                                        } else {
                                            if (this.state.Case.Case.ProductData?.Product == null) {
                                                return <></>
                                            } else {
                                                return <PulseLoader
                                                    size={10}
                                                    color={"#bbb"}
                                                    loading={true}
                                                />
                                            }
                                        }
                                    }
                                )()}
                                {this.state.Case.Case.ProductData?.Version && <p><b>Version:</b> {this.state.Case.Case.ProductData.Version}</p>}
                            </Col>
                            <Col md="3" className={`my-support-case-meta-inner`}>
                                {this.state.Case.Case.Status != 1 &&
                                    <div>
                                        <Button onClick={() => this.handleModalConfirmAction("closeCase")}>Close Case</Button>
                                        <Modal show={this.state.showConfirmModal && this.state.confirmAction == "closeCase"}
                                            backdrop="static"
                                            centered
                                            size={`sm`} className={`new-case-loading-modal`} onHide={() => this.handleShowConfirmModal(false)}>

                                            <Modal.Header closeButton>
                                                <Modal.Title>Close Case</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body style={{ "margin": "auto" }}>
                                                Are you sure you want to close this case?
                                        </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="secondary" onClick={() => this.handleShowConfirmModal(false)}>Go Back</Button>
                                                <Button variant="primary" onClick={() => this.changeCaseStatus(2)}>Confirm</Button>
                                            </Modal.Footer>
                                        </Modal>
                                        <Link to={`/`} className={`btn gc-btn btn-primary my-support-case-back`}>Back to My Cases</Link>
                                    </div>
                                }

                                {this.state.Case.Case.Status == 1 &&
                                    <div>
                                        <Link to={`/`} className={`btn gc-btn btn-primary my-support-case-back`}>Back to My Cases</Link>
                                    </div>
                                }
                            </Col>
                        </Row>
                    }

                    {(() => {

                        if (this.state.Case && (this.state.Case.Comments.length > 0 || this.state.Case.Case.Description.length > 0)) {
                            let _comments = this.state.Case.Comments.sort((a, b) => {
                                return new Date(a.CreatedOn) - new Date(b.CreatedOn);
                            }).map((comment, i) => {
                                return <Row key={`case-comment-${i}`} className={comment.IsCustomerComment ? "case-comment user-comment" : "case-comment agent-comment"} >

                                    <Col md="2" className={`case-comment-author`}>
                                        <p>Posted By:</p>
                                        <p>{comment.IsCustomerComment ? "You" : comment.From}</p>
                                        <p>{moment.utc(comment.CreatedOn).local().format('h:mm A')}<br />
                                            {moment.utc(comment.CreatedOn).local().format('MMMM D, YYYY')}</p>
                                    </Col>

                                    <Col md="10" className={`case-comment-inner`} >
                                        <div className={`body`}>
                                            <p dangerouslySetInnerHTML={{ __html: comment.Comment }} ></p>
                                        </div>

                                        {comment.Attachments.length > 0 &&
                                            <div className={`attachments`}>
                                                <h5>Attachments</h5>
                                                <ListGroup>
                                                    {((Attachments) => {
                                                        let attachments = Attachments.map(attachment => {
                                                            return <ListGroupItem action><div onClick={() => this.fetchFile(`/my-account/my-support/api/files/${attachment.AttachmentId}_${attachment.FileName}`,attachment.FileName)}><i class="fa fa-paperclip" aria-hidden="true"></i>{attachment.FileName}</div></ListGroupItem>
                                                        })
                                                        return attachments;
                                                    })(comment.Attachments)}
                                                </ListGroup>
                                            </div>
                                        }

                                    </Col>
                                </Row>
                            });


                            return (
                                <Row className={`my-support-case-body`}>
                                    <div className={`case-comments`}>
                                        {_comments}
                                    </div>
                                    {(() => {
                                        if (this.state.Case.Case.Status != 1) {
                                            return (
                                                <div className={`case-comments-editor-wrap`}>
                                                    <Row>
                                                        <Col md="12">
                                                            <h3>Add A Comment</h3>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col md="12">
                                                            {this.state.Alert &&
                                                                <Alert dismissible onClose={this.clearAlerts} variant={this.state.Alert.Status}>
                                                                    {this.state.Alert.Message}
                                                                </Alert>
                                                            }
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col md="12">
                                                            <MySupportEditor ref={this.Editor} onSubmit={this.addReply} disabledSubmit={
                                                                this.state.Loading
                                                            } />

                                                        </Col>
                                                    </Row>
                                                </div>
                                            )
                                        } else {
                                            return (
                                                <div className={`case-comments-editor-wrap`}>

                                                    <Row>
                                                        <Col md="12">
                                                            <Alert variant={`info`}>
                                                                <i>To reopen the case, please add a comment below.</i>
                                                            </Alert>
                                                            <MySupportEditor ref={this.Editor} onSubmit={(reply,attachments) => this.handleModalConfirmReopen("reopenCase", reply, attachments)} disabledSubmit={
                                                                this.state.Loading
                                                            } />
                                                            <Modal show={this.state.showConfirmModal && this.state.confirmAction == "reopenCase"}
                                                                backdrop="static"
                                                                centered
                                                                size={`md`} className={`new-case-loading-modal`} onHide={() => this.handleShowConfirmModal(false)}>

                                                                <Modal.Header closeButton>
                                                                    <Modal.Title>Reopen Case</Modal.Title>
                                                                </Modal.Header>
                                                                <Modal.Body style={{ "margin": "auto" }}>
                                                                    Would you like to reopen this closed cased?
                                                                </Modal.Body>
                                                                <Modal.Footer>
                                                                    <Button variant="secondary" onClick={async () =>{
                                                                        await this.addReply(this.state.reopenReply, this.state.reopenAttachments);
                                                                        this.setState({
                                                                            reopenReply: null,
                                                                            reopenAttachments:null,
                                                                            showConfirmModal:false
                                                                        })
                                                                    }}>Keep Closed</Button>
                                                                    <Button variant="primary" onClick={async () =>{
                                                                        await this.changeCaseStatus(1);
                                                                        await this.addReply(this.state.reopenReply, this.state.reopenAttachments);
                                                                        this.setState({
                                                                            reopenReply: null,
                                                                            reopenAttachments:null,
                                                                            showConfirmModal:false
                                                                        })
                                                                     } }>Reopen Case</Button>
                                                                </Modal.Footer>
                                                            </Modal>
                                                        </Col>
                                                    </Row>
                                                </div>)
                                        }
                                    })()}

                                </Row>)
                        }

                    })()}

                    {!this.state.Case && !this.state.Loading &&
                        <Alert variant={`danger`}>
                            Unable to find case details.
                    </Alert>
                    }

                </div>
            </div>
        )
    }
}

export default withRouter(MyCase);